module.exports = __webpack_public_path__ + "img/ascend_gold30.d1cfea75.png";